import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { faBars, faHome, faUserCircle, faSignOutAlt, faShoppingBasket, faMapMarkedAlt, faPeopleCarry, faUsersCog, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({

  
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],


 
})

export class HomeComponent implements OnInit {
  public telDina;
  private _mobileQueryListener: () => void;


public par =0;
  public arg = 1;
  nombre ="";
  email ="";
  telefono ="";
  mensaje ="";
  intervall;
  sube = false;
 corr = 0;
 err = 0;

 fot1;
 fot2;
 fot3;

 explora;
 social;
 contactof;

 home;
 nosotros;
 servicios;
 linkedin;
 instagram;


 nom;
 em;
 tel;
 msj;
 env;
 /*TALK
WHIT 
US.

name/e-mail/message/phone/send

EXPLORE / SOCIAL / CONTACT
Back to top
About Us
What we do
*/
homee;
about;
what;
 menu1;
 menu2;
 menu3;
 menu4;
 menu5;
/* Patagonia Chain
About Us
What we do
Talk with us*/




  ngOnInit(): void {

      
  
        

  }
   cl()
  {
 
  }



   onActivate(event) {   
        document.body.scrollTop=0; }

    portada()
      {
          this.router.navigate(['/']);
      }
    contacto()
      {
      
         if(this.router.url.indexOf("contac") > 0)  
         { document.getElementById("tarjet").style.top = "0";}
          else this.router.navigate(['/contactos']);
      }

 constructor(private authService: AuthService, private router: Router) { }

 




}